import script from "./CMI00310.vue?vue&type=script&setup=true&lang=ts"
export * from "./CMI00310.vue?vue&type=script&setup=true&lang=ts"

import "./CMI00310.vue?vue&type=style&index=0&id=2a93ba28&scoped=true&lang=css"
import "./CMI00310.vue?vue&type=style&index=1&id=2a93ba28&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a93ba28"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QRadio,QBtn,QChip});
